import { render } from "./MPSVIILeukocytes.vue?vue&type=template&id=78ac6f8f&scoped=true"
import script from "./MPSVIILeukocytes.vue?vue&type=script&lang=js"
export * from "./MPSVIILeukocytes.vue?vue&type=script&lang=js"

import "./MPSVIILeukocytes.vue?vue&type=style&index=0&id=78ac6f8f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ac6f8f"]])

export default __exports__